// modules/invitations/index.ts
import { ModuleConfig } from '@/core/module';
import { invitationRoutes, publicInvitationRoutes } from './routes';

export const InvitationsModule: ModuleConfig = {
    name: 'invitations',
    routes: invitationRoutes,
    stores: {},
    initialize: () => {
        console.log('Invitations module initialized');
    },
    cleanup: () => {
        console.log('Invitations module cleaned up');
    }
};

// Export public routes separately for use in main routes
export { publicInvitationRoutes };
